import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-up\"><path fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M16.5 8.5l-4-4-4 4m4-3.5v15\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol